import { Line } from './Line';
import { Row, ThemeText } from '@/components/Theme';

export const Textline = ({lineProps = {}, leftLineProps = {}, rightLineProps = {}, rowProps = {}, ...rest}) => (
    <Row flex={1} gap={25} alignItems={'center'} {...rowProps}>
        <Line flex={1} {...lineProps} {...leftLineProps} />
        <ThemeText {...rest} />
        <Line flex={1} {...lineProps} {...rightLineProps} />
    </Row>
)